var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteams = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "msteams",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "microsoftteamsDark",
  transform: "translate(1.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.8,8.1 L15,8.1 L15,13.9 C15,15.8 16.6,17.4 18.5,17.4 C20.4,17.4 22,15.8 22,13.9 L22,9.3 C22,8.6 21.5,8.1 20.8,8.1 Z",
  id: "Path",
  fill: "#485BD5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.8,8.1 L5.8,15.1 C5.8,18 8.1,20.6 11.2,20.8 C14.6,21 17.4,18.5 17.4,15.3 L17.4,9.2 C17.4,8.6 16.9,8.1 16.2,8.1 L5.8,8.1 Z",
  id: "Path_1_",
  fill: "#6D81FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6,0 C10.4,0 9.2,0.7 8.6,1.7 C8,2.7 8,4.1 8.6,5.2 C9.2,6.3 10.4,6.9 11.6,6.9 C12.8,6.9 14,6.2 14.6,5.2 C15.2,4.2 15.2,2.8 14.6,1.7 C14,0.6 12.8,0 11.6,0 L11.6,0 Z",
  id: "Path_2_",
  fill: "#5161CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5,1.2 C17.2,1.2 16.2,2.2 16.2,3.5 C16.2,4.8 17.2,5.8 18.5,5.8 C19.8,5.8 20.8,4.8 20.8,3.5 C20.8,2.2 19.8,1.2 18.5,1.2 Z",
  id: "Path_3_",
  fill: "#3440A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6,16.2 L1,16.2 C0.5,16.2 0,15.8 0,15.3 L0,6.7 C0,6.2 0.4,5.8 1,5.8 L10.6,5.8 C11.1,5.8 11.6,6.2 11.6,6.7 L11.6,15.4 C11.6,15.8 11.1,16.2 10.6,16.2 Z",
  id: "Path_4_",
  fill: "#2D399A"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path_5_",
  fill: "#FFFFFF",
  points: "8.1 8.1 3.5 8.1 3.5 9.1 5.2 9.1 5.2 13.9 6.4 13.9 6.4 9.1 8.1 9.1"
}))))));
export { SvgMicrosoftteams as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteams.46a3e2a8.svg";